import api from '../../plugins/api';

const getWdCar = (params) => {
  return api.get('/api/shop/getWdCar', params);
};

export default getWdCar;
